// /**
//  * Free Gift Sync — AlignerCo (Horizon theme)
//  *
//  * Keeps the free-gift line in the cart in sync with qualifying products:
//  *   - gift quantity = total quantity of qualifying products (1 SmileAdvantage -> 1 gift, 2 -> 2,
//  *     SmileAdvantage + NightFlex -> 2). The gift's +/- are locked; the remove button still works.
//  *   - Checkout clicked during a gift update      -> waits for the update (~1s), then continues
//  *   - Works the same in the theme cart drawer, the cart page and AMP's cart drawer.
//  *   - The gift's price shows "Free" (like checkout) instead of "$0.00".
//  *   - customer removes the gift completely   -> respect it, don't add it back (until no qualifying product is left)
//  *   - no qualifying product + gift           -> remove every gift line
//  *   - not enough stock                       -> give as many as Shopify allows; sold out -> skip quietly
//  *
//  * Settings come from snippets/free-gift-sync.liquid (window.FreeGiftSyncConfig).
//  * It only OBSERVES other cart requests (theme, AMP, other apps) and never modifies them.
//  * It never dispatches the theme's `cart:update` event (that would auto-open the cart drawer);
//  * it refreshes the cart UI with the theme's own section renderer instead.
//  */
// import { morphSection, sectionRenderer } from '@theme/section-renderer';

// const cfg = window.FreeGiftSyncConfig;

// if (cfg && cfg.enabled && !window.__freeGiftSyncLoaded) {
//   window.__freeGiftSyncLoaded = true;
//   initFreeGiftSync(cfg);
// }

// function initFreeGiftSync(cfg) {
//   const QUALIFYING_PRODUCT_IDS = new Set((cfg.qualifyingProductIds || []).map(String));
//   const GIFT_VARIANT_ID = String(cfg.giftVariantId);
//   if (!QUALIFYING_PRODUCT_IDS.size || !GIFT_VARIANT_ID) return;

//   const DEBOUNCE_MS = 150; // groups rapid clicks into one sync
//   const MAX_FIXES = 15; // safety net: at most 15 gift changes (normal shopping needs far fewer)...
//   const FIX_WINDOW_MS = 30000; // ...per 30 seconds, so a conflict can never loop forever
//   const MAX_BUSY_WAITS = 40; // wait up to ~6s for the theme's own cart update to finish
//   const CART_MUTATION_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

//   // `Theme` is a global const defined in snippets/scripts.liquid (not on window).
//   const routes = typeof Theme !== 'undefined' && Theme.routes ? Theme.routes : {};
//   const withJs = (url) => (url.endsWith('.js') ? url : `${url}.js`);
//   const CART_URL = withJs(routes.cart_url || '/cart');
//   const ADD_URL = withJs(routes.cart_add_url || '/cart/add');
//   const UPDATE_URL = withJs(routes.cart_update_url || '/cart/update');

//   // Our own requests use the original fetch, so they are never observed (no loops).
//   const nativeFetch = window.fetch.bind(window);

//   let timer = null;
//   let running = false;
//   let pending = false;
//   let busyWaits = 0;
//   let giftSoldOut = cfg.giftAvailable === false;
//   let fixLog = [];
//   let inflight = 0; // cart requests by the theme/apps that haven't finished yet
//   let latestCart = null; // newest full cart from a finished change/update reply
//   let giftTitle = cfg.giftTitle || ''; // used to find the gift line in AMP's drawer
//   const DECLINED_KEY = 'free-gift-declined';
//   const MAX_STOCK_STEPS = 5; // when stock is short, try at most 5 smaller quantities
//   let giftCap = Infinity; // highest gift quantity Shopify accepted when stock ran short
//   // Cart state when the page was rendered (from Liquid), then after each sync.
//   let lastState = { hasQualifier: !!cfg.initialHasQualifier, hasGift: !!cfg.initialHasGift };

//   /* ---------------- Change detection (observe only) ---------------- */

//   // 1) The theme's own cart signal (add to cart, quantity +/-, remove).
//   document.addEventListener('cart:update', schedule);

//   // 2) Any other cart request on the page (theme, AMP drawer, other apps). The original response is
//   //    returned untouched; we only read a copy. Shopify's change/update replies already contain the
//   //    full cart, so we reuse it instead of asking Shopify again (cart reads take 1-3 s on this store).
//   window.fetch = function (input, init) {
//     const request = nativeFetch(input, init);
//     try {
//       const url = input instanceof Request ? input.url : String(input);
//       if (CART_MUTATION_URL.test(url)) {
//         inflight++;
//         request.then(
//           (response) => {
//             let copy = null;
//             try {
//               copy = response.clone();
//             } catch (_) {
//               /* body already used elsewhere: we'll read the cart ourselves */
//             }
//             const done = (data) => {
//               inflight = Math.max(0, inflight - 1);
//               rememberCart(data);
//               schedule();
//             };
//             if (copy) copy.json().then(done, () => done(null));
//             else done(null);
//           },
//           () => {
//             inflight = Math.max(0, inflight - 1);
//             schedule();
//           }
//         );
//       }
//     } catch (_) {
//       /* never interfere with the original request */
//     }
//     return request;
//   };

//   // 3) Same for older XHR-based scripts (e.g. jQuery $.ajax).
//   const xhrOpen = XMLHttpRequest.prototype.open;
//   XMLHttpRequest.prototype.open = function (method, url) {
//     try {
//       if (CART_MUTATION_URL.test(String(url))) {
//         inflight++;
//         this.addEventListener('loadend', () => {
//           inflight = Math.max(0, inflight - 1);
//           let data = null;
//           try {
//             data = JSON.parse(this.responseText);
//           } catch (_) {
//             /* not JSON */
//           }
//           rememberCart(data);
//           schedule();
//         });
//       }
//     } catch (_) {
//       /* never interfere with the original request */
//     }
//     return xhrOpen.apply(this, arguments);
//   };

//   // Keep the newest full cart Shopify sent back (change/update replies). Any other reply (e.g. an
//   // add reply, which only lists the added items) makes the kept cart outdated, so it is dropped.
//   function rememberCart(data) {
//     const isFullCart = data && Array.isArray(data.items) && typeof data.item_count === 'number' && data.token;
//     latestCart = isFullCart ? data : null;
//   }

//   // 4) Page load (only when Liquid saw a mismatch) and back/forward cache restores.
//   if (cfg.syncOnLoad) schedule();
//   window.addEventListener('pageshow', (event) => {
//     if (event.persisted) schedule();
//   });

//   /* ---------------- Gift quantity lock (gift row only) ---------------- */

//   // The gift quantity is managed automatically, so its +/- are shown disabled (theme's own disabled style).
//   // The input is made read-only, NOT disabled: the cart form submits every quantity box on checkout,
//   // and a disabled box would be skipped and shift the other lines' quantities.
//   const GIFT_ROW = `tr[data-key^="${GIFT_VARIANT_ID}:"]`;
//   const GIFT_QTY_BUTTONS = 'button.quantity-minus, button.quantity-plus';
//   // AMP's own cart drawer: its lines have no product id, so the gift line is found by its title.
//   const AMP_LINE = '.amp-cart__cart-line';
//   const AMP_QTY_BUTTONS = '.amp-cart__line-quantity-selector-less, .amp-cart__line-quantity-selector-more';

//   function isAmpGiftLine(line) {
//     const title = line && line.querySelector('.amp-cart__cart-line-title');
//     return !!giftTitle && !!title && title.textContent.trim() === giftTitle;
//   }

//   // Show "Free" instead of "$0.00" on the gift line, like Shopify checkout does. Only text nodes that
//   // are a zero price are replaced, so each drawer keeps its own font, size and layout.
//   const FREE_LABEL = cfg.freeLabel || 'Free';
//   const ZERO_PRICE = /^(?=.*[^\d\s.,])[^\d]*0(?:[.,]00)?[^\d]*$/; // "$0.00", "$0", "0,00 €", "$0.00 USD"

//   function showFreeLabel(root) {
//     const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
//     let node;
//     while ((node = walker.nextNode())) {
//       const text = node.nodeValue.trim();
//       if (text && text !== FREE_LABEL && ZERO_PRICE.test(text)) node.nodeValue = FREE_LABEL;
//     }
//   }

//   function lockGiftQuantity() {
//     for (const row of document.querySelectorAll(GIFT_ROW)) {
//       for (const button of row.querySelectorAll(GIFT_QTY_BUTTONS)) {
//         if (!button.disabled) button.disabled = true;
//       }
//       const input = row.querySelector('input[ref="quantityInput"]');
//       if (input && !input.readOnly) input.readOnly = true;
//       showFreeLabel(row);
//     }
//     for (const line of document.querySelectorAll(AMP_LINE)) {
//       if (!isAmpGiftLine(line)) continue;
//       for (const button of line.querySelectorAll(AMP_QTY_BUTTONS)) {
//         if (!button.disabled) button.disabled = true;
//       }
//       const input = line.querySelector('.amp-cart__line-quantity-selector-input');
//       if (input && !input.readOnly) input.readOnly = true;
//       showFreeLabel(line);
//     }
//   }

//   // The theme and AMP re-render cart lines after every change (re-enabling buttons, writing "$0.00"
//   // again), so re-apply the lock and the "Free" label whenever that happens.
//   let lockQueued = false;
//   new MutationObserver(() => {
//     if (lockQueued) return;
//     lockQueued = true;
//     requestAnimationFrame(() => {
//       lockQueued = false;
//       lockGiftQuantity();
//     });
//   }).observe(document.documentElement, {
//     subtree: true,
//     childList: true,
//     characterData: true,
//     attributes: true,
//     attributeFilter: ['disabled'],
//   });
//   lockGiftQuantity();

//   // Safety net: ignore clicks on the gift's +/- (theme drawer, cart page and AMP drawer)
//   // even if a button is momentarily enabled.
//   document.addEventListener(
//     'click',
//     (event) => {
//       if (!(event.target instanceof Element)) return;
//       const themeButton = event.target.closest(GIFT_QTY_BUTTONS);
//       const ampButton = event.target.closest(AMP_QTY_BUTTONS);
//       const isGiftButton =
//         (themeButton && themeButton.closest(GIFT_ROW)) || (ampButton && isAmpGiftLine(ampButton.closest(AMP_LINE)));
//       if (isGiftButton) {
//         event.preventDefault();
//         event.stopImmediatePropagation();
//       }
//     },
//     true
//   );

//   /* ---------------- Checkout waits for a running gift update ---------------- */

//   // If Checkout is clicked while the gift is being updated (about 1 second after a cart change),
//   // wait until the cart is correct, then continue to checkout automatically. Never blocks for long.
//   // Covers the theme's Checkout (drawer + cart page) and AMP drawer's Checkout.
//   const CHECKOUT_BUTTONS = 'button[name="checkout"], .amp-cart__footer-checkout-button';
//   let resumingCheckout = false;
//   document.addEventListener(
//     'click',
//     async (event) => {
//       const button = event.target instanceof Element ? event.target.closest(CHECKOUT_BUTTONS) : null;
//       if (!button || resumingCheckout || isIdle()) return;

//       event.preventDefault();
//       event.stopImmediatePropagation();
//       const isAmp = button.matches('.amp-cart__footer-checkout-button');
//       await waitForIdle(4000);

//       // The drawer may have re-rendered meanwhile: click the current button of the same kind.
//       const target = button.isConnected
//         ? button
//         : (button.id && document.getElementById(button.id)) ||
//           document.querySelector(isAmp ? '.amp-cart__footer-checkout-button' : 'button[name="checkout"]');
//       resumingCheckout = true;
//       try {
//         target?.click();
//       } finally {
//         resumingCheckout = false;
//       }
//     },
//     true
//   );

//   function isIdle() {
//     return timer === null && !running && !pending && inflight === 0;
//   }

//   async function waitForIdle(maxMs) {
//     const started = Date.now();
//     while (!isIdle() && Date.now() - started < maxMs) {
//       await new Promise((resolve) => setTimeout(resolve, 100));
//     }
//   }

//   /* ---------------- Sync ---------------- */

//   function schedule() {
//     clearTimeout(timer);
//     timer = setTimeout(run, DEBOUNCE_MS);
//   }

//   async function run() {
//     timer = null;
//     if (running) {
//       pending = true;
//       return;
//     }
//     // If the theme or an app is in the middle of a cart update, wait for it to finish.
//     if ((inflight > 0 || document.querySelector('cart-items-component.cart-items-disabled')) && busyWaits < MAX_BUSY_WAITS) {
//       busyWaits++;
//       schedule();
//       return;
//     }
//     busyWaits = 0;
//     running = true;
//     try {
//       await sync();
//     } catch (error) {
//       console.warn('[free-gift] sync skipped:', error);
//     } finally {
//       running = false;
//       if (pending) {
//         pending = false;
//         schedule();
//       }
//     }
//   }

//   async function sync() {
//     // Reuse the full cart Shopify just sent back, if we have one; otherwise read it (slow on this store).
//     const cart = latestCart || (await getCart());
//     latestCart = null;
//     const items = cart.items || [];
//     const giftItem = items.find((item) => String(item.variant_id) === GIFT_VARIANT_ID);
//     if (giftItem && giftItem.product_title) giftTitle = giftItem.product_title;
//     // One gift per qualifying unit: 1 SmileAdvantage -> 1 gift, 2 -> 2, SmileAdvantage + NightFlex -> 2.
//     const target = items
//       .filter((item) => QUALIFYING_PRODUCT_IDS.has(String(item.product_id)))
//       .reduce((sum, item) => sum + item.quantity, 0);
//     const giftLines = items.filter((item) => String(item.variant_id) === GIFT_VARIANT_ID);
//     const giftQty = giftLines.reduce((sum, item) => sum + item.quantity, 0);
//     const hasQualifier = target > 0;
//     const hasGift = giftQty > 0;

//     // No qualifying product: remove the gift and reset the customer's "no thanks" choice.
//     if (!hasQualifier) {
//       if (isDeclined(cart.token)) setDeclined(cart.token, false);
//       let removed = !hasGift;
//       if (hasGift && allowFix()) removed = await withCartLocked(() => setGiftLines(giftLines, 0));
//       lastState = { hasQualifier: false, hasGift: !removed };
//       return;
//     }

//     // Never more gifts than are left in stock (learned when Shopify refuses a quantity).
//     const wanted = Math.min(target, giftCap);

//     // Qualifying product + gift: make the gift quantity match (one line, `wanted` units).
//     if (hasGift) {
//       if (isDeclined(cart.token)) setDeclined(cart.token, false);
//       if ((giftQty !== wanted || giftLines.length > 1) && allowFix()) {
//         await withCartLocked(async () => {
//           if (wanted > giftQty) {
//             // More gifts needed. Shopify's "update" does NOT check stock, but "add" does, so first
//             // merge into one line at the current quantity (if needed), then add only the extra gifts.
//             if (giftLines.length > 1) await setGiftLines(giftLines, giftQty);
//             await addMoreGifts(cart, giftQty, wanted - giftQty);
//           } else {
//             await setGiftLines(giftLines, wanted); // fewer gifts (or merge lines): no stock involved
//           }
//         });
//       }
//       lastState = { hasQualifier: true, hasGift: true };
//       return;
//     }

//     // Qualifying product, no gift. If the gift was there a moment ago (with a qualifying product),
//     // the customer removed it themselves: respect that and don't add it back.
//     if (lastState.hasQualifier && lastState.hasGift) setDeclined(cart.token, true);

//     let added = false;
//     if (!isDeclined(cart.token) && !giftSoldOut && wanted > 0 && allowFix()) {
//       added = await withCartLocked(() => addGift(cart, wanted));
//     }
//     lastState = { hasQualifier: true, hasGift: added };
//   }

//   // The customer's "no thanks" choice is remembered per cart in this browser (not sent to Shopify).
//   function isDeclined(cartToken) {
//     try {
//       return !!cartToken && localStorage.getItem(DECLINED_KEY) === String(cartToken);
//     } catch (_) {
//       return false;
//     }
//   }

//   function setDeclined(cartToken, value) {
//     try {
//       if (value && cartToken) localStorage.setItem(DECLINED_KEY, String(cartToken));
//       else localStorage.removeItem(DECLINED_KEY);
//     } catch (_) {
//       /* storage unavailable: fall back to normal behaviour */
//     }
//   }

//   // Add `quantity` gifts. If Shopify refuses (not enough stock), step down until it fits.
//   async function addGift(cart, quantity) {
//     for (let qty = quantity, tries = 0; qty > 0 && tries < MAX_STOCK_STEPS; qty--, tries++) {
//       const response = await nativeFetch(
//         ADD_URL,
//         postJSON({
//           items: [{ id: Number(GIFT_VARIANT_ID), quantity: qty, properties: { _free_gift: 'true' } }],
//           ...sectionsPayload(),
//         })
//       );
//       const data = await response.json().catch(() => ({}));

//       if (response.ok && !data.status) {
//         if (qty < quantity) giftCap = qty;
//         refreshCartUI(data.sections, (cart.item_count || 0) + qty);
//         return true;
//       }
//       if (response.status !== 422 && data.status !== 422) return false; // other error: try again later
//     }
//     giftSoldOut = true; // out of stock / unavailable: stop trying on this page
//     return false;
//   }

//   // Add `extra` gifts to a cart that already has `current`. If Shopify refuses (not enough stock),
//   // try fewer; if none fit, remember the current quantity as the most we can give.
//   async function addMoreGifts(cart, current, extra) {
//     for (let qty = extra, tries = 0; qty > 0 && tries < MAX_STOCK_STEPS; qty--, tries++) {
//       const response = await nativeFetch(
//         ADD_URL,
//         postJSON({
//           items: [{ id: Number(GIFT_VARIANT_ID), quantity: qty, properties: { _free_gift: 'true' } }],
//           ...sectionsPayload(),
//         })
//       );
//       const data = await response.json().catch(() => ({}));

//       if (response.ok && !data.status) {
//         if (qty < extra) giftCap = current + qty;
//         refreshCartUI(data.sections, (cart.item_count || 0) + qty);
//         return true;
//       }
//       if (response.status !== 422 && data.status !== 422) return false; // other error: try again later
//     }
//     giftCap = current; // no more stock: keep what the customer already has
//     return false;
//   }

//   // Set the gift to `quantity` units on the first gift line and remove any extra gift lines.
//   async function setGiftLines(giftLines, quantity) {
//     for (let qty = quantity, tries = 0; tries < MAX_STOCK_STEPS; qty--, tries++) {
//       const updates = {};
//       giftLines.forEach((line, index) => {
//         updates[line.key] = index === 0 ? Math.max(qty, 0) : 0;
//       });

//       const response = await nativeFetch(UPDATE_URL, postJSON({ updates, ...sectionsPayload() }));
//       const data = await response.json().catch(() => ({}));

//       if (response.ok && !data.status) {
//         // Shopify may quietly lower the quantity to what's in stock: remember that as the cap.
//         const actual = Array.isArray(data.items)
//           ? data.items
//               .filter((item) => String(item.variant_id) === GIFT_VARIANT_ID)
//               .reduce((sum, item) => sum + item.quantity, 0)
//           : qty;
//         if (actual < qty) giftCap = actual;
//         else if (qty < quantity) giftCap = qty;
//         refreshCartUI(data.sections, data.item_count);
//         return true;
//       }
//       if ((response.status !== 422 && data.status !== 422) || qty <= 1) return false;
//     }
//     return false;
//   }

//   /* ---------------- Helpers ---------------- */

//   async function getCart() {
//     const response = await nativeFetch(CART_URL, {
//       headers: { Accept: 'application/json' },
//       cache: 'no-store',
//     });
//     if (!response.ok) throw new Error(`cart.js ${response.status}`);
//     return response.json();
//   }

//   function postJSON(body) {
//     return {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//       body: JSON.stringify(body),
//     };
//   }

//   function cartSectionIds() {
//     const ids = new Set();
//     for (const el of document.querySelectorAll('cart-items-component')) {
//       if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
//     }
//     return Array.from(ids);
//   }

//   // Ask Shopify to return the fresh cart HTML in the same request (no extra round trip).
//   function sectionsPayload() {
//     const ids = cartSectionIds();
//     return ids.length ? { sections: ids.join(','), sections_url: window.location.pathname } : {};
//   }

//   // Re-render the cart drawer / cart page and the header count with the theme's own functions.
//   function refreshCartUI(sectionsHtml, itemCount) {
//     for (const sectionId of cartSectionIds()) {
//       const html = sectionsHtml && sectionsHtml[sectionId];
//       const rerender = () => sectionRenderer.renderSection(sectionId, { cache: false }).catch(() => {});
//       if (html) {
//         Promise.resolve()
//           .then(() => morphSection(sectionId, html))
//           .catch(rerender);
//       } else {
//         rerender();
//       }
//     }

//     for (const selector of document.querySelectorAll('cart-quantity-selector-component')) {
//       selector.updateButtonStates?.();
//     }

//     if (typeof itemCount === 'number') {
//       for (const icon of document.querySelectorAll('cart-icon')) {
//         icon.renderCartBubble?.(itemCount, false, false);
//       }
//     }
//   }

//   // Briefly block clicks on cart rows (theme's existing class) while line numbers change.
//   async function withCartLocked(task) {
//     const components = document.querySelectorAll('cart-items-component');
//     components.forEach((el) => el.classList.add('cart-items-disabled'));
//     try {
//       return await task();
//     } finally {
//       components.forEach((el) => el.classList.remove('cart-items-disabled'));
//     }
//   }

//   function allowFix() {
//     const now = Date.now();
//     fixLog = fixLog.filter((time) => now - time < FIX_WINDOW_MS);
//     if (fixLog.length >= MAX_FIXES) {
//       console.warn('[free-gift] paused: too many gift changes in a short time');
//       return false;
//     }
//     fixLog.push(now);
//     return true;
//   }
// }

/**
 * Free Gift Sync — AlignerCo (Horizon theme)
 *
 * Keeps the free-gift line in the cart in sync with qualifying products:
 *   - gift quantity = total quantity of qualifying products (1 SmileAdvantage -> 1 gift, 2 -> 2,
 *     SmileAdvantage + NightFlex -> 2). The gift's +/- are locked; the remove button still works.
 *   - Checkout clicked during a gift update      -> waits for the update (~1s), then continues
 *   - Works the same in the theme cart drawer, the cart page and AMP's cart drawer.
 *   - The gift's price shows "Free" (like checkout) instead of "$0.00".
 *   - customer removes the gift completely   -> respect it, don't add it back (until no qualifying product is left)
 *   - no qualifying product + gift           -> remove every gift line
 *   - not enough stock                       -> give as many as Shopify allows; sold out -> skip quietly
 *
 * Settings come from snippets/free-gift-sync.liquid (window.FreeGiftSyncConfig).
 * It only OBSERVES other cart requests (theme, AMP, other apps) and never modifies them.
 * It never dispatches the theme's `cart:update` event (that would auto-open the cart drawer);
 * it refreshes the cart UI with the theme's own section renderer instead.
 */
import { morphSection, sectionRenderer } from '@theme/section-renderer';

const cfg = window.FreeGiftSyncConfig;

if (cfg && cfg.enabled && !window.__freeGiftSyncLoaded) {
  window.__freeGiftSyncLoaded = true;
  initFreeGiftSync(cfg);
}

function initFreeGiftSync(cfg) {
  const QUALIFYING_PRODUCT_IDS = new Set((cfg.qualifyingProductIds || []).map(String));
  const GIFT_VARIANT_ID = String(cfg.giftVariantId);
  const EXCLUDED_VARIANT_IDS = new Set((cfg.excludedVariantIds || []).map(String));
  if (!QUALIFYING_PRODUCT_IDS.size || !GIFT_VARIANT_ID) return;

  const DEBOUNCE_MS = 150; // groups rapid clicks into one sync
  const MAX_FIXES = 15; // safety net: at most 15 gift changes (normal shopping needs far fewer)...
  const FIX_WINDOW_MS = 30000; // ...per 30 seconds, so a conflict can never loop forever
  const MAX_BUSY_WAITS = 40; // wait up to ~6s for the theme's own cart update to finish
  const CART_MUTATION_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  // `Theme` is a global const defined in snippets/scripts.liquid (not on window).
  const routes = typeof Theme !== 'undefined' && Theme.routes ? Theme.routes : {};
  const withJs = (url) => (url.endsWith('.js') ? url : `${url}.js`);
  const CART_URL = withJs(routes.cart_url || '/cart');
  const ADD_URL = withJs(routes.cart_add_url || '/cart/add');
  const UPDATE_URL = withJs(routes.cart_update_url || '/cart/update');

  // Our own requests use the original fetch, so they are never observed (no loops).
  const nativeFetch = window.fetch.bind(window);

  let timer = null;
  let running = false;
  let pending = false;
  let busyWaits = 0;
  let giftSoldOut = cfg.giftAvailable === false;
  let fixLog = [];
  let inflight = 0; // cart requests by the theme/apps that haven't finished yet
  let latestCart = null; // newest full cart from a finished change/update reply
  let giftTitle = cfg.giftTitle || ''; // used to find the gift line in AMP's drawer
  const DECLINED_KEY = 'free-gift-declined';
  const MAX_STOCK_STEPS = 5; // when stock is short, try at most 5 smaller quantities
  let giftCap = Infinity; // highest gift quantity Shopify accepted when stock ran short
  // Cart state when the page was rendered (from Liquid), then after each sync.
  let lastState = { hasQualifier: !!cfg.initialHasQualifier, hasGift: !!cfg.initialHasGift };

  /* ---------------- Change detection (observe only) ---------------- */

  // 1) The theme's own cart signal (add to cart, quantity +/-, remove).
  document.addEventListener('cart:update', schedule);

  // 2) Any other cart request on the page (theme, AMP drawer, other apps). The original response is
  //    returned untouched; we only read a copy. Shopify's change/update replies already contain the
  //    full cart, so we reuse it instead of asking Shopify again (cart reads take 1-3 s on this store).
  window.fetch = function (input, init) {
    const request = nativeFetch(input, init);
    try {
      const url = input instanceof Request ? input.url : String(input);
      if (CART_MUTATION_URL.test(url)) {
        inflight++;
        request.then(
          (response) => {
            let copy = null;
            try {
              copy = response.clone();
            } catch (_) {
              /* body already used elsewhere: we'll read the cart ourselves */
            }
            const done = (data) => {
              inflight = Math.max(0, inflight - 1);
              rememberCart(data);
              schedule();
            };
            if (copy) copy.json().then(done, () => done(null));
            else done(null);
          },
          () => {
            inflight = Math.max(0, inflight - 1);
            schedule();
          }
        );
      }
    } catch (_) {
      /* never interfere with the original request */
    }
    return request;
  };

  // 3) Same for older XHR-based scripts (e.g. jQuery $.ajax).
  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (CART_MUTATION_URL.test(String(url))) {
        inflight++;
        this.addEventListener('loadend', () => {
          inflight = Math.max(0, inflight - 1);
          let data = null;
          try {
            data = JSON.parse(this.responseText);
          } catch (_) {
            /* not JSON */
          }
          rememberCart(data);
          schedule();
        });
      }
    } catch (_) {
      /* never interfere with the original request */
    }
    return xhrOpen.apply(this, arguments);
  };

  // Keep the newest full cart Shopify sent back (change/update replies). Any other reply (e.g. an
  // add reply, which only lists the added items) makes the kept cart outdated, so it is dropped.
  function rememberCart(data) {
    const isFullCart = data && Array.isArray(data.items) && typeof data.item_count === 'number' && data.token;
    latestCart = isFullCart ? data : null;
  }

  // 4) Page load (only when Liquid saw a mismatch) and back/forward cache restores.
  if (cfg.syncOnLoad) schedule();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) schedule();
  });

  /* ---------------- Gift quantity lock (gift row only) ---------------- */

  // The gift quantity is managed automatically, so its +/- are shown disabled (theme's own disabled style).
  // The input is made read-only, NOT disabled: the cart form submits every quantity box on checkout,
  // and a disabled box would be skipped and shift the other lines' quantities.
  const GIFT_ROW = `tr[data-key^="${GIFT_VARIANT_ID}:"]`;
  const GIFT_QTY_BUTTONS = 'button.quantity-minus, button.quantity-plus';
  // AMP's own cart drawer: its lines have no product id, so the gift line is found by its title.
  const AMP_LINE = '.amp-cart__cart-line';
  const AMP_QTY_BUTTONS = '.amp-cart__line-quantity-selector-less, .amp-cart__line-quantity-selector-more';

  function isAmpGiftLine(line) {
    const title = line && line.querySelector('.amp-cart__cart-line-title');
    return !!giftTitle && !!title && title.textContent.trim() === giftTitle;
  }

  // Show "Free" instead of "$0.00" on the gift line, like Shopify checkout does. Only text nodes that
  // are a zero price are replaced, so each drawer keeps its own font, size and layout.
  const FREE_LABEL = cfg.freeLabel || 'Free';
  const ZERO_PRICE = /^(?=.*[^\d\s.,])[^\d]*0(?:[.,]00)?[^\d]*$/; // "$0.00", "$0", "0,00 €", "$0.00 USD"

  function showFreeLabel(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const text = node.nodeValue.trim();
      if (text && text !== FREE_LABEL && ZERO_PRICE.test(text)) node.nodeValue = FREE_LABEL;
    }
  }

  function lockGiftQuantity() {
    for (const row of document.querySelectorAll(GIFT_ROW)) {
      for (const button of row.querySelectorAll(GIFT_QTY_BUTTONS)) {
        if (!button.disabled) button.disabled = true;
      }
      const input = row.querySelector('input[ref="quantityInput"]');
      if (input && !input.readOnly) input.readOnly = true;
      showFreeLabel(row);
    }
    for (const line of document.querySelectorAll(AMP_LINE)) {
      if (!isAmpGiftLine(line)) continue;
      for (const button of line.querySelectorAll(AMP_QTY_BUTTONS)) {
        if (!button.disabled) button.disabled = true;
      }
      const input = line.querySelector('.amp-cart__line-quantity-selector-input');
      if (input && !input.readOnly) input.readOnly = true;
      showFreeLabel(line);
    }
  }

  // The theme and AMP re-render cart lines after every change (re-enabling buttons, writing "$0.00"
  // again), so re-apply the lock and the "Free" label whenever that happens.
  let lockQueued = false;
  new MutationObserver(() => {
    if (lockQueued) return;
    lockQueued = true;
    requestAnimationFrame(() => {
      lockQueued = false;
      lockGiftQuantity();
    });
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['disabled'],
  });
  lockGiftQuantity();

  // Safety net: ignore clicks on the gift's +/- (theme drawer, cart page and AMP drawer)
  // even if a button is momentarily enabled.
  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;
      const themeButton = event.target.closest(GIFT_QTY_BUTTONS);
      const ampButton = event.target.closest(AMP_QTY_BUTTONS);
      const isGiftButton =
        (themeButton && themeButton.closest(GIFT_ROW)) || (ampButton && isAmpGiftLine(ampButton.closest(AMP_LINE)));
      if (isGiftButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  /* ---------------- Checkout waits for a running gift update ---------------- */

  // If Checkout is clicked while the gift is being updated (about 1 second after a cart change),
  // wait until the cart is correct, then continue to checkout automatically. Never blocks for long.
  // Covers the theme's Checkout (drawer + cart page) and AMP drawer's Checkout.
  const CHECKOUT_BUTTONS = 'button[name="checkout"], .amp-cart__footer-checkout-button';
  let resumingCheckout = false;
  document.addEventListener(
    'click',
    async (event) => {
      const button = event.target instanceof Element ? event.target.closest(CHECKOUT_BUTTONS) : null;
      if (!button || resumingCheckout || isIdle()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const isAmp = button.matches('.amp-cart__footer-checkout-button');
      await waitForIdle(4000);

      // The drawer may have re-rendered meanwhile: click the current button of the same kind.
      const target = button.isConnected
        ? button
        : (button.id && document.getElementById(button.id)) ||
          document.querySelector(isAmp ? '.amp-cart__footer-checkout-button' : 'button[name="checkout"]');
      resumingCheckout = true;
      try {
        target?.click();
      } finally {
        resumingCheckout = false;
      }
    },
    true
  );

  function isIdle() {
    return timer === null && !running && !pending && inflight === 0;
  }

  async function waitForIdle(maxMs) {
    const started = Date.now();
    while (!isIdle() && Date.now() - started < maxMs) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
  }

  /* ---------------- Sync ---------------- */

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, DEBOUNCE_MS);
  }

  async function run() {
    timer = null;
    if (running) {
      pending = true;
      return;
    }
    // If the theme or an app is in the middle of a cart update, wait for it to finish.
    if ((inflight > 0 || document.querySelector('cart-items-component.cart-items-disabled')) && busyWaits < MAX_BUSY_WAITS) {
      busyWaits++;
      schedule();
      return;
    }
    busyWaits = 0;
    running = true;
    try {
      await sync();
    } catch (error) {
      console.warn('[free-gift] sync skipped:', error);
    } finally {
      running = false;
      if (pending) {
        pending = false;
        schedule();
      }
    }
  }

  async function sync() {
    // Reuse the full cart Shopify just sent back, if we have one; otherwise read it (slow on this store).
    const cart = latestCart || (await getCart());
    latestCart = null;
    const items = cart.items || [];
    const giftItem = items.find((item) => String(item.variant_id) === GIFT_VARIANT_ID);
    if (giftItem && giftItem.product_title) giftTitle = giftItem.product_title;
    // One gift per qualifying unit: 1 SmileAdvantage -> 1 gift, 2 -> 2, SmileAdvantage + NightFlex -> 2.
    const target = items
      .filter((item) => QUALIFYING_PRODUCT_IDS.has(String(item.product_id)) && !EXCLUDED_VARIANT_IDS.has(String(item.variant_id)))
      .reduce((sum, item) => sum + item.quantity, 0);
    const giftLines = items.filter((item) => String(item.variant_id) === GIFT_VARIANT_ID);
    const giftQty = giftLines.reduce((sum, item) => sum + item.quantity, 0);
    const hasQualifier = target > 0;
    const hasGift = giftQty > 0;

    // No qualifying product: remove the gift and reset the customer's "no thanks" choice.
    if (!hasQualifier) {
      if (isDeclined(cart.token)) setDeclined(cart.token, false);
      let removed = !hasGift;
      if (hasGift && allowFix()) removed = await withCartLocked(() => setGiftLines(giftLines, 0));
      lastState = { hasQualifier: false, hasGift: !removed };
      return;
    }

    // Never more gifts than are left in stock (learned when Shopify refuses a quantity).
    const wanted = Math.min(target, giftCap);

    // Qualifying product + gift: make the gift quantity match (one line, `wanted` units).
    if (hasGift) {
      if (isDeclined(cart.token)) setDeclined(cart.token, false);
      if ((giftQty !== wanted || giftLines.length > 1) && allowFix()) {
        await withCartLocked(async () => {
          if (wanted > giftQty) {
            // More gifts needed. Shopify's "update" does NOT check stock, but "add" does, so first
            // merge into one line at the current quantity (if needed), then add only the extra gifts.
            if (giftLines.length > 1) await setGiftLines(giftLines, giftQty);
            await addMoreGifts(cart, giftQty, wanted - giftQty);
          } else {
            await setGiftLines(giftLines, wanted); // fewer gifts (or merge lines): no stock involved
          }
        });
      }
      lastState = { hasQualifier: true, hasGift: true };
      return;
    }

    // Qualifying product, no gift. If the gift was there a moment ago (with a qualifying product),
    // the customer removed it themselves: respect that and don't add it back.
    if (lastState.hasQualifier && lastState.hasGift) setDeclined(cart.token, true);

    let added = false;
    if (!isDeclined(cart.token) && !giftSoldOut && wanted > 0 && allowFix()) {
      added = await withCartLocked(() => addGift(cart, wanted));
    }
    lastState = { hasQualifier: true, hasGift: added };
  }

  // The customer's "no thanks" choice is remembered per cart in this browser (not sent to Shopify).
  function isDeclined(cartToken) {
    try {
      return !!cartToken && localStorage.getItem(DECLINED_KEY) === String(cartToken);
    } catch (_) {
      return false;
    }
  }

  function setDeclined(cartToken, value) {
    try {
      if (value && cartToken) localStorage.setItem(DECLINED_KEY, String(cartToken));
      else localStorage.removeItem(DECLINED_KEY);
    } catch (_) {
      /* storage unavailable: fall back to normal behaviour */
    }
  }

  // Add `quantity` gifts. If Shopify refuses (not enough stock), step down until it fits.
  async function addGift(cart, quantity) {
    for (let qty = quantity, tries = 0; qty > 0 && tries < MAX_STOCK_STEPS; qty--, tries++) {
      const response = await nativeFetch(
        ADD_URL,
        postJSON({
          items: [{ id: Number(GIFT_VARIANT_ID), quantity: qty, properties: { _free_gift: 'true' } }],
          ...sectionsPayload(),
        })
      );
      const data = await response.json().catch(() => ({}));

      if (response.ok && !data.status) {
        if (qty < quantity) giftCap = qty;
        refreshCartUI(data.sections, (cart.item_count || 0) + qty);
        return true;
      }
      if (response.status !== 422 && data.status !== 422) return false; // other error: try again later
    }
    giftSoldOut = true; // out of stock / unavailable: stop trying on this page
    return false;
  }

  // Add `extra` gifts to a cart that already has `current`. If Shopify refuses (not enough stock),
  // try fewer; if none fit, remember the current quantity as the most we can give.
  async function addMoreGifts(cart, current, extra) {
    for (let qty = extra, tries = 0; qty > 0 && tries < MAX_STOCK_STEPS; qty--, tries++) {
      const response = await nativeFetch(
        ADD_URL,
        postJSON({
          items: [{ id: Number(GIFT_VARIANT_ID), quantity: qty, properties: { _free_gift: 'true' } }],
          ...sectionsPayload(),
        })
      );
      const data = await response.json().catch(() => ({}));

      if (response.ok && !data.status) {
        if (qty < extra) giftCap = current + qty;
        refreshCartUI(data.sections, (cart.item_count || 0) + qty);
        return true;
      }
      if (response.status !== 422 && data.status !== 422) return false; // other error: try again later
    }
    giftCap = current; // no more stock: keep what the customer already has
    return false;
  }

  // Set the gift to `quantity` units on the first gift line and remove any extra gift lines.
  async function setGiftLines(giftLines, quantity) {
    for (let qty = quantity, tries = 0; tries < MAX_STOCK_STEPS; qty--, tries++) {
      const updates = {};
      giftLines.forEach((line, index) => {
        updates[line.key] = index === 0 ? Math.max(qty, 0) : 0;
      });

      const response = await nativeFetch(UPDATE_URL, postJSON({ updates, ...sectionsPayload() }));
      const data = await response.json().catch(() => ({}));

      if (response.ok && !data.status) {
        // Shopify may quietly lower the quantity to what's in stock: remember that as the cap.
        const actual = Array.isArray(data.items)
          ? data.items
              .filter((item) => String(item.variant_id) === GIFT_VARIANT_ID)
              .reduce((sum, item) => sum + item.quantity, 0)
          : qty;
        if (actual < qty) giftCap = actual;
        else if (qty < quantity) giftCap = qty;
        refreshCartUI(data.sections, data.item_count);
        return true;
      }
      if ((response.status !== 422 && data.status !== 422) || qty <= 1) return false;
    }
    return false;
  }

  /* ---------------- Helpers ---------------- */

  async function getCart() {
    const response = await nativeFetch(CART_URL, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });
    if (!response.ok) throw new Error(`cart.js ${response.status}`);
    return response.json();
  }

  function postJSON(body) {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    };
  }

  function cartSectionIds() {
    const ids = new Set();
    for (const el of document.querySelectorAll('cart-items-component')) {
      if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
    }
    return Array.from(ids);
  }

  // Ask Shopify to return the fresh cart HTML in the same request (no extra round trip).
  function sectionsPayload() {
    const ids = cartSectionIds();
    return ids.length ? { sections: ids.join(','), sections_url: window.location.pathname } : {};
  }

  // Re-render the cart drawer / cart page and the header count with the theme's own functions.
  function refreshCartUI(sectionsHtml, itemCount) {
    for (const sectionId of cartSectionIds()) {
      const html = sectionsHtml && sectionsHtml[sectionId];
      const rerender = () => sectionRenderer.renderSection(sectionId, { cache: false }).catch(() => {});
      if (html) {
        Promise.resolve()
          .then(() => morphSection(sectionId, html))
          .catch(rerender);
      } else {
        rerender();
      }
    }

    for (const selector of document.querySelectorAll('cart-quantity-selector-component')) {
      selector.updateButtonStates?.();
    }

    if (typeof itemCount === 'number') {
      for (const icon of document.querySelectorAll('cart-icon')) {
        icon.renderCartBubble?.(itemCount, false, false);
      }
    }
  }

  // Briefly block clicks on cart rows (theme's existing class) while line numbers change.
  async function withCartLocked(task) {
    const components = document.querySelectorAll('cart-items-component');
    components.forEach((el) => el.classList.add('cart-items-disabled'));
    try {
      return await task();
    } finally {
      components.forEach((el) => el.classList.remove('cart-items-disabled'));
    }
  }

  function allowFix() {
    const now = Date.now();
    fixLog = fixLog.filter((time) => now - time < FIX_WINDOW_MS);
    if (fixLog.length >= MAX_FIXES) {
      console.warn('[free-gift] paused: too many gift changes in a short time');
      return false;
    }
    fixLog.push(now);
    return true;
  }
}